var config        = require("app/config"),
    get           = require("object-path").get,
    quickMacroize = require("enyo/macroize").quickMacroize;

/**
 * Helper that adds an object with commonly used links to the Media Item.
 *
 * @param    {string}   language         The current application language
 * @param    {Object}   media            The media item
 * @param    {Object=}  playlistDetails  Optional associated playlist
 * @returns  {Object}   The media item with additional `links` object injected
 */
module.exports = function(language, media, playlistDetails) {
    var artistSlug             = get(playlistDetails, "artistSlug", null),
        playlistSlug           = get(playlistDetails, "playlistSlug", null),
        categorySlug           = get(playlistDetails, "categorySlug", null),
        musicAlbumSlug,
        seriesSlug,
        seasonNr,
        magazineSlug,
        yearNr,
        podcastSlug,
        omitPlaylistParameters = false,
        shareParameters,
        playlistParameters,
        urlSearchParams;

    media.links = media.links || {};

    switch (media.type) {
        case "album_track":
            musicAlbumSlug = get(media, "parent_slug", null) || get(media, "parent.meta.slug", null);

            if (musicAlbumSlug) {
                media.links.self = quickMacroize("/{$language}/music-album/{$musicAlbumSlug}/{$mediaType}/{$mediaSlug}", {
                    language:       language,
                    musicAlbumSlug: musicAlbumSlug,
                    mediaType:      media.type.replaceAll("_", "-"),
                    mediaSlug:      get(media, "meta.slug", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.expandedPlayer = quickMacroize("/{$language}/listen/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            // Player Link > Playlist on Artist Page
            if (artistSlug && playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/artist-page/{$artistSlug}/playlist/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    artistSlug:   artistSlug,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Playlist Page
            else if (playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/playlist-page/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Music Album Page
            else if (musicAlbumSlug) {
                media.links.player = quickMacroize("/{$language}/music-album/{$musicAlbumSlug}/listen/{$mediaSlug}", {
                    language:       language,
                    musicAlbumSlug: musicAlbumSlug,
                    mediaSlug:      get(media, "meta.slug", null)
                });
            }
            else {
                media.links.player = media.links.expandedPlayer;
            }

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "artist_page":
            media.links.self = quickMacroize("/{$language}/artist-page/{$mediaSlug}", {
                language:  language,
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "audio":
            media.links.self = quickMacroize("/{$language}/audio/{$mediaSlug}", {
                language:  language,
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.expandedPlayer = quickMacroize("/{$language}/listen/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            // Player Link > Playlist on Artist Page
            if (artistSlug && playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/artist-page/{$artistSlug}/playlist/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    artistSlug:   artistSlug,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Playlist Page
            else if (playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/playlist-page/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Audio Page
            else {
                media.links.player = quickMacroize("/{$language}/{$mediaType}/{$mediaSlug}/listen", {
                    language:  language,
                    mediaType: media.type.replaceAll("_", "-"),
                    mediaSlug: get(media, "meta.slug", null)
                });
            }

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "book":
            media.links.self = quickMacroize("/{$language}/book/{$mediaSlug}", {
                language:  language,
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.player = quickMacroize("/{$language}/read/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "brand":
            media.links.self = quickMacroize("/{$language}/brand/{$brandSlug}", {
                language:  language,
                brandSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "category":
            if (media.category_type === "root") {
                media.links.self = quickMacroize("/{$language}/home", {
                    language: language
                });
            }
            else {
                media.links.self = quickMacroize("/{$language}/category/{$categorySlug}", {
                    language:     language,
                    categorySlug: get(media, "meta.slug", null)
                });
            }

            media.links.share = media.links.self;
            break;
        case "episode":
            seriesSlug = get(media, "parent.parent.meta.slug", null);
            seasonNr   = get(media, "parent.serial_nr", null);

            if (seriesSlug && seasonNr) {
                media.links.self = quickMacroize("/{$language}/series/{$seriesSlug}/season/{$seasonNr}/{$mediaType}/{$mediaSlug}", {
                    language:   language,
                    seriesSlug: seriesSlug,
                    seasonNr:   seasonNr,
                    mediaType:  media.type.replaceAll("_", "-"),
                    mediaSlug:  get(media, "meta.slug", null)
                });
            }
            else if (seriesSlug) {
                media.links.self = quickMacroize("/{$language}/series/{$seriesSlug}/{$mediaType}/{$mediaSlug}", {
                    language:   language,
                    seriesSlug: seriesSlug,
                    mediaType:  media.type.replaceAll("_", "-"),
                    mediaSlug:  get(media, "meta.slug", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.player = quickMacroize("/{$language}/play/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "external":
            break;
        case "issue":
            magazineSlug = get(media, "parent.parent.meta.slug", null);
            yearNr       = get(media, "parent.serial_nr", null);

            if (magazineSlug && yearNr) {
                media.links.self = quickMacroize("/{$language}/magazine/{$magazineSlug}/year/{$yearNr}/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    magazineSlug: magazineSlug,
                    yearNr:       yearNr,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
            }
            else if (magazineSlug) {
                media.links.self = quickMacroize("/{$language}/magazine/{$magazineSlug}/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    magazineSlug: magazineSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.player = quickMacroize("/{$language}/read/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "magazine":
            media.links.self = quickMacroize("/{$language}/magazine/{$magazineSlug}", {
                language:     language,
                magazineSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "music_album":
            media.links.self = quickMacroize("/{$language}/music-album/{$musicAlbumSlug}", {
                language:       language,
                musicAlbumSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "page":
            media.links.self = quickMacroize("/{$language}/micro-page/{$pageSlug}", {
                language: language,
                pageSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "photo":
            media.links.self = get(media, "meta.slug", null)
                ? quickMacroize("/{$language}/view/{$mediaType}/{$mediaSlug}", {
                    language:  language,
                    mediaType: media.type.replaceAll("_", "-"),
                    mediaSlug: get(media, "meta.slug", null)
                })
                : quickMacroize("/{$language}/view/{$mediaType}/id/{$mediaId}", {
                    language:  language,
                    mediaType: media.type.replaceAll("_", "-"),
                    mediaId:   get(media, "id", null)
                });

            media.links.player = media.links.self;

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "playlist_page":
            media.links.self = quickMacroize("/{$language}/playlist-page/{$mediaSlug}", {
                language:  language,
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "podcast":
            media.links.self = quickMacroize("/{$language}/podcast/{$podcastSlug}", {
                language:    language,
                podcastSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "podcast_episode":
            podcastSlug = get(media, "parent_slug", null) || get(media, "parent.meta.slug", null);

            if (podcastSlug) {
                media.links.self = quickMacroize("/{$language}/podcast/{$podcastSlug}/{$mediaType}/{$mediaSlug}", {
                    language:    language,
                    podcastSlug: podcastSlug,
                    mediaType:   media.type.replaceAll("_", "-"),
                    mediaSlug:   get(media, "meta.slug", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.expandedPlayer = quickMacroize("/{$language}/listen/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            // Player Link > Playlist on Artist Page
            if (artistSlug && playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/artist-page/{$artistSlug}/playlist/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    artistSlug:   artistSlug,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Playlist Page
            else if (playlistSlug) {
                media.links.player     = quickMacroize("/{$language}/playlist-page/{$playlistSlug}/listen/{$mediaType}/{$mediaSlug}", {
                    language:     language,
                    playlistSlug: playlistSlug,
                    mediaType:    media.type.replaceAll("_", "-"),
                    mediaSlug:    get(media, "meta.slug", null)
                });
                omitPlaylistParameters = true;
            }

            // Player Link > Podcast Page
            else if (podcastSlug) {
                media.links.player = quickMacroize("/{$language}/podcast/{$podcastSlug}/listen/{$mediaSlug}", {
                    language:    language,
                    podcastSlug: podcastSlug,
                    mediaSlug:   get(media, "meta.slug", null)
                });
            }
            else {
                media.links.player = media.links.expandedPlayer;
            }

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "product":
            media.links.self = quickMacroize("/{$language}/product/{$productSlug}", {
                language:    language,
                productSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "product_category":
            media.links.self  = quickMacroize("/{$language}/product-category/{$productCategorySlug}", {
                language:            language,
                productCategorySlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "season":
            seriesSlug = get(media, "parent_slug", null) || get(media, "parent.meta.slug", null);

            if (seriesSlug) {
                media.links.self = quickMacroize("/{$language}/series/{$seriesSlug}/season/{$seasonNr}", {
                    language:   language,
                    seriesSlug: seriesSlug,
                    seasonNr:   get(media, "serial_nr", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.share = media.links.self;
            break;
        case "series":
            media.links.self = quickMacroize("/{$language}/series/{$seriesSlug}", {
                language:   language,
                seriesSlug: get(media, "meta.slug", null)
            });

            media.links.share = media.links.self;
            break;
        case "video":
            media.links.self = quickMacroize("/{$language}/video/{$mediaSlug}", {
                language:  language,
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.player = quickMacroize("/{$language}/play/{$mediaType}/{$mediaSlug}", {
                language:  language,
                mediaType: media.type.replaceAll("_", "-"),
                mediaSlug: get(media, "meta.slug", null)
            });

            media.links.share = get(config, "sharing.directPlay", false)
                ? media.links.player
                : media.links.self;
            break;
        case "year":
            magazineSlug = get(media, "parent_slug", null) || get(media, "parent.meta.slug", null);

            if (magazineSlug) {
                media.links.self = quickMacroize("/{$language}/magazine/{$magazineSlug}/year/{$yearNr}", {
                    language:     language,
                    magazineSlug: magazineSlug,
                    yearNr:       get("media", "serial_nr", null)
                });
            }
            else {
                media.links.self = null;
            }

            media.links.share = media.links.self;
            break;
        default:
            break;
    }

    // Add playlist details
    if ((artistSlug && playlistSlug) || playlistSlug || categorySlug) {
        switch (media.type) {
            case "album_track":
            case "audio":
            case "book":
            case "episode":
            case "issue":
            case "photo":
            case "podcast_episode":
            case "video":
                media.playlistDetails = {};
                ["artistSlug", "playlistSlug", "categorySlug"].forEach(function(prop) {
                    if (playlistDetails[prop]) {
                        media.playlistDetails[prop] = playlistDetails[prop];
                    }
                });
                break;
            default:
                break;
        }
    }

    // Build query parameters sets
    shareParameters    = ["shared=1"];
    playlistParameters = [];

    if (media.playlistDetails && !omitPlaylistParameters) {
        Object.keys(media.playlistDetails).forEach(function(key) {
            playlistParameters.push([
                // Key converted to snake case
                key.replace(/([A-Z])/g, "_$1").toLowerCase(),
                media.playlistDetails[key]
            ].join("="));
        });
    }

    // Apply query parameters
    if (media.links.share) {
        urlSearchParams = [];

        if (media.links.share === media.links.player) {
            urlSearchParams = urlSearchParams.concat(playlistParameters);
        }

        urlSearchParams = urlSearchParams.concat(shareParameters);

        if (urlSearchParams.length) {
            media.links.share += "?" + urlSearchParams.join("&");
        }
    }

    if (media.links.player) {
        urlSearchParams = playlistParameters;

        if (urlSearchParams.length) {
            media.links.player += "?" + urlSearchParams.join("&");
        }
    }

    if (media.links.expandedPlayer) {
        urlSearchParams = playlistParameters;

        if (urlSearchParams.length) {
            media.links.expandedPlayer += "?" + urlSearchParams.join("&");
        }
    }

    if (media.links.self && media.type === "photo") {
        urlSearchParams = playlistParameters;

        if (urlSearchParams.length) {
            media.links.self += "?" + urlSearchParams.join("&");
        }
    }

    return media;
};
